import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const blocks = [
  {
    title: 'Rotativa en streaming',
    subtitle: 'Rotativa en streaming · señal 24/7',
    bullets: [
      '12 spots diarios (20 s) distribuidos en la programación.',
      '4 historias semanales en streaming: narrativa de marca en la señal TNO.',
      '4 reels al mes: limpieza en acción en sede y estudios con Danimar (redes y ecosistema).',
      'Frases directas y sonidos que evoquen limpieza profunda y frescura.',
    ],
  },
  {
    title: 'TNO Digest (SEO y Google)',
    subtitle: 'Autoridad en búsqueda',
    bullets: [
      '4 artículos al mes, siempre (orden, limpieza, bienestar, higiene) redactados por el equipo periodístico de TNO.',
      'Editorial alineado con el calendario en señal: mismas promesas que reels e historias semanales.',
      'Ejemplo de artículo: «Guía de ahorro y eficiencia: optimizar detergentes Danimar en mantenimiento industrial».',
      'Enlaces directos a canales de venta para conversión.',
    ],
  },
  {
    title: 'Ecosistema digital (banners)',
    subtitle: 'Presencia en la web TNO',
    bullets: [
      'Banner publicitario en el portal principal de TNO Network con enlace a catálogo o Instagram.',
      'Presencia en la sección de aliados destacados.',
    ],
  },
];

const Visibility360 = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Estrategia
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Visibilidad 360°
      </Typography>
      <Typography variant="body1" color="textSecondary" align="center" paragraph sx={{ maxWidth: 640, mx: 'auto' }}>
        Tres frentes coordinados para que la marca suene, se lea y se vea en todo el ecosistema.
      </Typography>
      <Grid container spacing={3}>
        {blocks.map((b, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                {b.title}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1.5 }}>
                {b.subtitle}
              </Typography>
              <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                {b.bullets.map((line, j) => (
                  <Typography key={j} component="li" variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Visibility360;
